export default __webpack_public_path__ + "static/media/section-bg-search-slide1.6ab1fa14.jpg";